import { getSupportType } from "@core/actions/complaintAction.ts";
import { getProfilTransfer } from "@core/actions/usersActions.ts";
import { FetchStatusType } from "@core/modeles/model.ts";
import { loadingSupport, supportLists } from "@core/slice/ComplaintSlice.ts";
import { profilTransfer } from "@core/slice/UsersSlice.ts";
import { useAppDispatch, useAppSelector } from "@core/store/hook.ts";
import { SupportTypeModel } from "@modules/plaintes/plaintes.model.ts";
import { UserDTO } from "@modules/setting/userManagement/user.model.ts";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from "primereact/multiselect";
import React from "react";

interface SolutionImplementProps {
  selectedInstruction: SupportTypeModel[];
  setSelectedInstruction: (a: any) => void;
  selectedSend: any;
  setSelectedSend: (a: any) => void;
  agentName: string;
  errors: any;
  setErrors: (a: any) => void;
  userConnect: UserDTO | null;
  isDisabled: boolean;
}

const SolutionImplement: React.FC<SolutionImplementProps> = ({
  selectedInstruction,
  setSelectedInstruction,
  selectedSend,
  setSelectedSend,
  agentName,
  errors,
  setErrors,
  isDisabled,
}) => {
  const dispatch = useAppDispatch();
  const profil = useAppSelector(profilTransfer);
  const listsSupport = useAppSelector(supportLists);
  const loadingSelect = useAppSelector(loadingSupport);
  const typeOrder = [
    "INTERNAL",
    "EXTERNAL",
    "ADMIN",
    "RGS",
    "CGP",
    "PFM",
    "COMPETENT_ENTITY",
  ];

  const sortedDropdown =  profil.toSorted((a, b) => {
    const indexA = typeOrder.indexOf(a.type);
    const indexB = typeOrder.indexOf(b.type);
    return indexA - indexB;
  });


  React.useEffect(() => {
    dispatch(getProfilTransfer());
    dispatch(getSupportType());
  }, [dispatch]);

  React.useEffect(() => {
    if (profil.length === 1) {
      setSelectedSend(profil[0]);
    }
    // eslint-disable-next-line
  }, [profil]);

  return (
    <div className="rounded-[10px] bg-white flex flex-col p-4">
      {isDisabled && (
        <div className="w-full text-center text-red-400">
          <i>Cette plainte est résolue. Le transfert n'est plus possible.</i>
        </div>
      )}
      <span className="text-black text-sm font-semibold mb-2">
        Solution à mettre en oeuvres :
      </span>
      <div className="w-full flex items-center">
        <div className="w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 ">
            <div className="flex flex-wrap gap-3">
              <div className="flex-auto column gap-2 w-full">
                <label htmlFor="instruction">
                  Instruction et prise en charge (obligatoire)
                </label>
                <MultiSelect
                  id="instruction"
                  value={selectedInstruction}
                  disabled={isDisabled}
                  onChange={(e: DropdownChangeEvent) => {
                    setSelectedInstruction(e.value);
                    setErrors({ ...errors, instruction: "" });
                  }}
                  options={listsSupport}
                  optionLabel="description"
                  placeholder="---Prise en charge---"
                  className="w-full md:w-14rem border border-solid border-[#d1d5db] h-[38px]"
                  selectAllLabel="Tout séléctionner"
                  loading={loadingSelect === FetchStatusType.LOADING}
                />
              </div>
              {errors.instruction && (
                <small className="text-red-600">{errors.instruction}</small>
              )}
            </div>
            <div className="flex flex-wrap gap-3">
              <div className="flex-auto column gap-2 w-full">
                <label htmlFor="sendTo">Envoyer vers (obligatoire)</label>
                <Dropdown
                  id="sendTo"
                  disabled={profil.length === 1 || isDisabled}
                  value={selectedSend}
                  onChange={(e: DropdownChangeEvent) => {
                    setSelectedSend(e.value);
                    setErrors({ ...errors, send: "" });
                  }}
                  options={sortedDropdown}
                  optionLabel="name"
                  placeholder="---envoyer vers---"
                  className="w-full md:w-14rem"
                />
              </div>
              {errors.send && (
                <small className="text-red-600">{errors.send}</small>
              )}
            </div>
          </div>
          <div>
            <label htmlFor="complainantName" className="block font-medium mb-2 mt-2 lg:mt-0">
              {/* Nom de l'agent interne ou MPS */}
              Nom de l'agent du [nom du partenaire externe]
            </label>
            <InputText
              value={agentName}
              placeholder="Entrer le nom de l'agent"
              className="w-full"
              disabled
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SolutionImplement;
